import { render, staticRenderFns } from "./AdminCampaigns.vue?vue&type=template&id=3578c4c5&scoped=true"
import script from "./AdminCampaigns.vue?vue&type=script&lang=js"
export * from "./AdminCampaigns.vue?vue&type=script&lang=js"
import style0 from "./AdminCampaigns.vue?vue&type=style&index=0&id=3578c4c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3578c4c5",
  null
  
)

export default component.exports